var map = {
	"./digital-art-competition_concept_character.jpg": 85257,
	"./digital-art-competition_concept_environment.jpg": 80267,
	"./digital-art-competition_concept_object.jpg": 32463,
	"./digital-art-competition_illustration_character.jpg": 9867,
	"./digital-art-competition_illustration_environment.jpg": 19709,
	"./digital-art-competition_illustration_object.jpg": 78437,
	"./digital-art-competition_public_award.jpg": 98672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72680;